module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "rt-overlay",
    style: ({
      background: _vm.overlayBackground,
      'z-index': _vm.zIndex,
      display: _vm.center ? 'flex' : 'block'
    })
  }, [_c('div', {
    staticClass: "rt-overlay-back",
    on: {
      "click": _vm.onClose
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65df30b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/overlay/rtOverlay.vue
// module id = 2109
// module chunks = 228